module.exports = __webpack_public_path__ + "img/exmplainer_planning_1.b7c39418.svg";